/* eslint-disable prettier/prettier */
import P from 'prop-types';
import React, { useState, useContext } from 'react';
import { Modal } from '../Modal';
import { LabelPreco } from '../LabelPreco';
import { Image } from '../Image';
import { toast } from 'react-toastify';
import './styles.css';
import { GetMontagem, GetStatusLoja } from '../../utils/utils';
import { GlobalContext } from '../../contexts/HomeContext';
import { trackMetaPixelEvent, trackGAEvent } from '../../utils/tracking';

export const Produtos = React.memo(function Produtos({
  item,
  diasRestricao = {},
  isSearch = false,
  onOpen,
  onAdded,
}) {
  //export const Produtos = ({ item, diasRestricao = {}, isSearch = false }) => {
  const { dadosApp, statusLoja, setStatusLoja } = useContext(GlobalContext);
  // VALORES INICIAIS DEFAULT DOS PRODUTOS
  item.id = 0;
  item.preco_pizza = 0;
  item.quantidade = 0; // correção bug pizza, aqui era o problema, estava com default 1
  item.quantidade_fracionada = 0;
  item.quantidade_texto = 0;
  item.observacao = '';
  //item.tipo_produto = item.tipo_produto;
  item.tipoPizza = 'INTEIRA';
  // VALORES INICIAIS DEFAULT DOS PRODUTOS
  //alert('zerou');
  const bloqueado = item?.bloqueado === 1 || item?.desativado === 1;

  const color = `${!diasRestricao.podeVender ? 'silver' : bloqueado ? 'silver' : ''}`;

  const [visibility, setShowHideModal] = useState('none');

  const trackViewContent = () => {
    trackMetaPixelEvent('ViewContent', {
      content_name: item.descricao,
      content_ids: [item.codigo?.toString() || item.codigo_produto?.toString()],
      content_type: 'product',
      value: parseFloat(item.preco_app || 0),
      currency: 'BRL',
    });

    trackGAEvent('Ecommerce', 'ViewContent', item.descricao, parseFloat(item.preco_app || 0));
  };

  const showHideModal = async () => {
    let msg = 'Produto não disponível';
    if (bloqueado) {
      toast.error(msg, { autoClose: 2500, });
      if (dadosApp.Qs.cardapioDigital !== "true") return;
    }

    if (!diasRestricao.podeVender) {
      if (!diasRestricao.eHoje && diasRestricao.dias != '')
        msg =
          'Somente às: ' +
          diasRestricao.dias
            .replace('Seg', 'Segunda')
            .replace('Ter', 'Terça')
            .replace('Qua', 'Quarta')
            .replace('Qui', 'Quinta')
            .replace('Sex', 'Sexta')
            .replace('Sab', 'Sábado')
            .replace('Sáb', 'Sábado')
            .replace('Dom', 'Domingo');
      if (diasRestricao.eHoje && diasRestricao.horario != '') msg = 'Somente: ' + diasRestricao.horario;

      toast.error(msg, {
        autoClose: 2500,
      });
      return;
    }

    const aberta = await GetStatusLoja(dadosApp, statusLoja, setStatusLoja);
    if (!aberta && dadosApp?.Empresa?.Config?.agendamento === 0) {
      toast.error('Loja Fechada', { containerId: 'toastGeral', autoClose: 2500 });
      return;
    }

    // Track ViewContent event - Product viewed
    trackViewContent();

    if (typeof onOpen === 'function') onOpen(item);

    setShowHideModal(visibility == 'none' ? 'block' : 'none');
  };

  return (
    <>
      <div className={!isSearch ? 'col-md-6' : 'col-md6-4'} key={item.codigo} id={item.codigo} onClick={showHideModal}>
        <a className="menu_item">
          {!item.caminho_img && (
            <div>
              <h3 style={{ color: color }}>{item.descricao.toLowerCase()}</h3>
              <p style={{ color: color }}>{item.obs_produto.toLowerCase()}</p>
              <LabelPreco
                className={`lista_item_preco ${!diasRestricao.podeVender ? 'silver' : bloqueado ? 'silver' : ''}`}
                price={item.preco_app}
                is_principal_multpreco={item.is_principal_multpreco}
              />
            </div>
          )}
          {!!item.caminho_img && (
            <div>
              <div id={item.codigo_produto + item.caminho_img} className="item_descricao">
                <h3 style={{ color: color }}>{item.descricao.toLowerCase()}</h3>
                <p style={{ color: color }}>{item.obs_produto.toLowerCase()}</p>
                <LabelPreco
                  className={`lista_item_preco ${!diasRestricao.podeVender ? 'silver' : bloqueado ? 'silver' : ''}`}
                  price={item.preco_app}
                  is_principal_multpreco={item.is_principal_multpreco}
                />
              </div>
              <div>
                <Image
                  src={item.caminho_img}
                  alt={item.descricao.toLowerCase()}
                  element={item.codigo_produto + item.caminho_img}
                />
              </div>
            </div>
          )}
        </a>
      </div>

      {visibility === 'block' && (
        <Modal
          title={item.descricao}
          isFooter={false}
          visibility={visibility}
          param={{
            item: item,
            montagem: GetMontagem(dadosApp, item.codigo, item.id, item),
          }}
          page="DETALHES"
          onAdded={onAdded}
          btnOnClickClose={showHideModal}
        />
      )}
    </>
  );
});

Produtos.propTypes = {
  item: P.object.isRequired,
  diasRestricao: P.object,
  isSearch: P.bool,
  onOpen: P.func,
  onClose: P.func,
  onAdded: P.func,
};
